import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const RoleBasedRoute = ({ children, allowedRoles, fallbackPath = '/dashboard' }) => {
  const { user, loading, hasAnyRole } = useUser();

  // Show loading while user data is being fetched
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Loading...</p>
        </div>
      </div>
    );
  }

  // If no user or user doesn't have required role, redirect
  if (!user || !hasAnyRole(allowedRoles)) {
    return <Navigate to={fallbackPath} replace />;
  }

  // User has required role, render the component
  return children;
};

export default RoleBasedRoute;
